import {
    GET_TILE_RECIPES_LOADING,
    GET_TILE_RECIPES_SUCCESS,
    GET_TILE_RECIPES_FAILURE
} from '../actionTypes'
import store from '../store';
import { showUnknownError } from './keyboard-shortcuts.actions';
import { client } from '../../services/client';
import { getRecursivelyAsync } from '../../utils/get-recursively-async';

export const getTileRecipesSuccess = payload => ({
    type: GET_TILE_RECIPES_SUCCESS,
    payload
})

export const getTileRecipesFailure = () => ({
    type: GET_TILE_RECIPES_FAILURE
})

export const getTileRecipesAsync = payload => dispatch => {
    return dispatch(getRecursivelyAsync('tile-recipes', getTileRecipesSuccess, 0));
}